@if (!eventClosed) {
  <div
    [ngClass]="{'text-danger': timeLeft! <= 0, 'text-warning': timeLeft! <= 12, 'text-success': timeLeft! > 12}"
    class="ms-2 p-1">
    <i class="bi bi-hourglass-split me-2"></i>
    @if (timeLeft! > 0 && !withSeconds) {
      <span>{{ timeLeft! | countdown }}</span>
    }
    @if (timeLeft! > 0 && withSeconds) {
      <span>{{ timeLeft! | countdownWithSeconds }}</span>
    }
  </div>
}
@if (eventClosed) {
  <span><i class="bi bi-hourglass-bottom mx-1"></i>Beendet</span>
}
